// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PDFViewer_pdfTemp__p-nip {
  height: 600px;
  position: relative;
  margin: 500px;
}

.PDFViewer_pdfNavigation__EQ\\+Rl {
  display: flex;
  justify-content: center;
  margin: -12px 0 12px 0;
  position: relative;
}

.PDFViewer_pdfPageText__XBIVV {
  text-align: center;
  padding: 13px 10px 0 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PDFViewer/PDFViewer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[".pdfTemp {\n  height: 600px;\n  position: relative;\n  margin: 500px;\n}\n\n.pdfNavigation {\n  display: flex;\n  justify-content: center;\n  margin: -12px 0 12px 0;\n  position: relative;\n}\n\n.pdfPageText {\n  text-align: center;\n  padding: 13px 10px 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pdfTemp": `PDFViewer_pdfTemp__p-nip`,
	"pdfNavigation": `PDFViewer_pdfNavigation__EQ+Rl`,
	"pdfPageText": `PDFViewer_pdfPageText__XBIVV`
};
export default ___CSS_LOADER_EXPORT___;
